<template>
  <b-badge :id="`popover-irregular-presence-logs-${mandateId}`" pill variant="warning">
    <font-awesome-icon icon="question" size="1x" />
    <b-popover
      :target="`popover-irregular-presence-logs-${mandateId}`"
      triggers="hover"
      placement="top"
    >
      Quelque chose s'est mal passé. <br />
      Les journaux de présence sont irréguliers
    </b-popover>
  </b-badge>
</template>

<script>
export default {
  props: {
    mandateId: {
      type: String,
      default: "",
      required: true,
    },
  },
};
</script>
